import type { HelperWorkspaceSummary } from '../../services/helper/helperStore'
import type { Workspace } from '../../types/workspace'

// Guard against workspaces missing the optional cardBackgroundSettings block —
// synthetic/debug workspaces and un-migrated docs both hit this path.
export const toMemberTodosWorkspaceSummary = (workspace: Workspace): HelperWorkspaceSummary => ({
  id: workspace.id,
  name: workspace.name,
  cardBackgroundsEnabled: workspace.cardBackgroundSettings?.enabled ?? false,
})
